import React, { Fragment } from "react";
import "./IconText.scss";
import classNames from "classnames";
import { withDefaults } from "../../utils/withDefaults";

export const ICON_PLACEMENT = {
  FIRST: "FIRST",
  SECOND: "SECOND",
  AROUND: "AROUND"
} as const;

export type IconPlacement =
  (typeof ICON_PLACEMENT)[keyof typeof ICON_PLACEMENT];

export interface IconTextProps {
  onClick?: (event: React.MouseEvent) => void;
  iconPlacement?: IconPlacement;
  wrapperClassName?: string;
  children?: React.ReactNode;
}

export default function IconText(incomingProps: IconTextProps) {
  const props = withDefaults(incomingProps, iconTextDefaultProps);

  return (
    <Fragment>
      <div
        className={classNames(
          "icon-text",
          props.wrapperClassName,
          `icon-${props.iconPlacement.toLowerCase()}`
        )}
        onClick={props.onClick}
      >
        {props.children}
      </div>
    </Fragment>
  );
}

const iconTextDefaultProps = {
  onClick: () => {},
  iconPlacement: ICON_PLACEMENT.FIRST,
  wrapperClassName: ""
};
